import { InjectionToken } from '@angular/core';
import { InMemoryCache } from 'apollo-cache-inmemory';

export const API_IN_MEMORY_CACHE = new InjectionToken<InMemoryCache>('API_IN_MEMORY_CACHE');
